import styled from 'styled-components/macro';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

export const HoverCard = styled(HoverCardPrimitive.Root)``;
